import { iOSAgent } from '../utils/useragent';

class VideoTeaserV2 {
  private videoPlay: Element | null;
  private video: Element | null;
  private videoEl: Element | null;
  private closeVideo: Element | null;

  cache() {
    this.videoPlay = document.querySelector('.js-video-play');
    this.video = document.querySelector('.js-video');
    // @ts-ignore
    this.videoEl = this.video?.querySelector('video');
    this.closeVideo = document.querySelector('.js-video-close');
  }

  bindings() {
    if (iOSAgent || !this.videoEl) {
      this.video?.classList.add('hidden');
      return false;
    }

    this.playVideo();

    this.videoPlay?.addEventListener('click', (e: Event) => {
      e.preventDefault();
      this.toggleVideo();
    });

    this.closeVideo?.addEventListener('click', (e: Event) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      // @ts-ignore
      this.videoEl?.pause();
    });
  }

  playVideo() {
    // @ts-ignore
    this.videoEl?.play();
  }

  toggleVideo() {
    // @ts-ignore
    if (this.videoEl?.paused) {
      // @ts-ignore
      this.videoEl?.play();
    }
    else {
      // @ts-ignore
      this.videoEl?.pause();
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default VideoTeaserV2;
